document.addEventListener('DOMContentLoaded', function () {
    const grid = document.getElementById('blogGrid');
    const noResults = document.getElementById('noResults');

    const monthFilter = document.getElementById('monthFilter');
    const sortTitle = document.getElementById('sortByTitle');
    const filterYear = document.getElementById('yearFilter');
    const filterState = document.getElementById('stateFilter');

    const searchToggle = document.getElementById('searchToggle');
    const searchInput = document.getElementById('searchInput');
    const searchWrapper = document.querySelector('.search-wrapper');
    const clearSearch = document.getElementById('clearSearch');

    /* =========================
       CONFIG
    ========================== */
    const PER_LOAD = 20;
    let visibleCount = PER_LOAD;

    /* =========================
       SORT: Upcoming first
    ========================== */
    function sortByEventStartDate(list) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        return list.sort((a, b) => {
            const dateA = new Date(a.startDate);
            const dateB = new Date(b.startDate);

            const isAFuture = dateA >= today;
            const isBFuture = dateB >= today;

            if (isAFuture && !isBFuture) return -1;
            if (!isAFuture && isBFuture) return 1;
            if (isAFuture && isBFuture) return dateA - dateB;

            return dateB - dateA; // past → recent first
        });
    }

    /* =========================
       READ ALL ARTICLES
    ========================== */
    const allArticles = Array.from(document.querySelectorAll('.article-data')).map(el => ({
        title: (el.dataset.title || '').toLowerCase(),
        startDate: el.dataset.startDate || '',
        endDate: el.dataset.endDate || '',
        year: el.dataset.year || '',
        month: el.dataset.month || '',
        monthShort: el.dataset.monthShort || '',
        location: (el.dataset.location || '').toLowerCase(),
        state: (el.dataset.state || '').toLowerCase(),
        html: el.dataset.html
    }));

    let filteredArticles = sortByEventStartDate([...allArticles]);

    /* =========================
       POPULATE FILTERS
    ========================== */
    [...new Set(allArticles.map(a => a.year).filter(Boolean))]
        .sort((a, b) => b - a)
        .forEach(y => {
            const opt = document.createElement('option');
            opt.value = y;
            opt.textContent = y;
            filterYear.appendChild(opt);
        });

    [...new Set(allArticles.map(a => a.state).filter(Boolean))]
        .sort()
        .forEach(s => {
            const opt = document.createElement('option');
            opt.value = s;
            opt.textContent = s;
            filterState.appendChild(opt);
        });

    /* =========================
       SEARCH UI
    ========================== */
    searchToggle.addEventListener('click', () => {
        const isVisible = searchWrapper.style.display === 'inline-block';
        searchWrapper.style.display = isVisible ? 'none' : 'inline-block';
        if (!isVisible) searchInput.focus();
    });

    clearSearch.addEventListener('click', () => {
        searchInput.value = '';
        clearSearch.style.display = 'none';
        applyFilters();
    });

    /* =========================
       APPLY FILTERS
    ========================== */
    function applyFilters() {
        const searchTerm = searchInput.value.trim().toLowerCase();
        visibleCount = PER_LOAD;

        filteredArticles = sortByEventStartDate([...allArticles]);

        if (searchTerm) {
            filteredArticles = filteredArticles.filter(a =>
                a.title.includes(searchTerm) ||
                a.location.includes(searchTerm) ||
                a.state.includes(searchTerm) ||
                a.month.includes(searchTerm) ||
                a.monthShort.includes(searchTerm) ||
                a.startDate.includes(searchTerm) ||
                a.endDate.includes(searchTerm)
            );
        }

        if (filterYear.value) {
            filteredArticles = filteredArticles.filter(a => a.year === filterYear.value);
        }

        if (filterState.value) {
            filteredArticles = filteredArticles.filter(a => a.state === filterState.value);
        }

        if (monthFilter.value) {
            filteredArticles = filteredArticles.filter(a => a.month === monthFilter.value);
        }

        if (sortTitle.value) {
            filteredArticles.sort((a, b) =>
                sortTitle.value === 'title-asc'
                    ? a.title.localeCompare(b.title)
                    : b.title.localeCompare(a.title)
            );
        }

        render(true);
    }

    /* =========================
       RENDER
    ========================== */
    function render(reset = false) {
        if (reset) grid.innerHTML = '';

        noResults.style.display = 'none';

        if (!filteredArticles.length) {
            noResults.style.display = 'block';
            return;
        }

        const items = filteredArticles.slice(0, visibleCount);
        grid.innerHTML = items.map(a => a.html).join('');
    }

    /* =========================
       INFINITE SCROLL
    ========================== */
    window.addEventListener('scroll', () => {
        if (
            window.innerHeight + window.scrollY >=
            document.body.offsetHeight - 300
        ) {
            if (visibleCount < filteredArticles.length) {
                visibleCount += PER_LOAD;
                render();
            }
        }
    });

    /* =========================
       EVENTS
    ========================== */
    searchInput.addEventListener('input', () => {
        clearSearch.style.display = searchInput.value.length ? 'block' : 'none';
        applyFilters();
    });

    monthFilter.addEventListener('change', applyFilters);
    sortTitle.addEventListener('change', applyFilters);
    filterYear.addEventListener('change', applyFilters);
    filterState.addEventListener('change', applyFilters);

    /* =========================
       INITIAL LOAD
    ========================== */
    render(true);
});